export default "__VITE_ASSET__Cz9EbSiL__"